/* eslint-disable radix */
/* eslint-disable indent */
/* eslint-disable eqeqeq */
/* eslint-disable quotes */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable no-loop-func */
/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable import/no-cycle */
/* eslint-disable object-shorthand */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unstable-nested-components */

function compareObjects(obj1, obj2) {
    const result = {
        old_value: {},
        new_value: {}
    };

    // Get all unique keys from both objects
    const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
      allKeys.delete('element_color');
      allKeys.delete('flow');
      allKeys.delete('FileName');
      allKeys.delete('FilePath');
    // eslint-disable-next-line
    for (const key of allKeys) {
        const val1 = obj1[key];
        const val2 = obj2[key];

        // Check if key exists in both objects
        if (!(key in obj1)) {
            // Key only exists in obj2
            result.old_value[key] = '';
            result.new_value[key] = val2;
        } else if (!(key in obj2)) {
            // Key only exists in obj1
            result.old_value[key] = val1;
            result.new_value[key] = '';
        } else {
            // Key exists in both objects
            // Check if both values are objects (and not arrays or null)
            if (typeof val1 === 'object' && val1 !== null && !Array.isArray(val1) &&
                typeof val2 === 'object' && val2 !== null && !Array.isArray(val2)) {
                // Both are objects, compare recursively
                const nestedComparison = compareObjects(val1, val2);

                // Only include if there are actual differences
                if (Object.keys(nestedComparison.old_value).length > 0 ||
                    Object.keys(nestedComparison.new_value).length > 0) {
                    result.old_value[key] = nestedComparison.old_value;
                    result.new_value[key] = nestedComparison.new_value;
                }
            } else if (JSON.stringify(val1) !== JSON.stringify(val2)) {
                // Values are different
                result.old_value[key] = val1;
                result.new_value[key] = val2;
            }
        }
    }

    return result;
}

// Function to get differences as structured JSON object
export const getObjectDifferences = (obj1, obj2) => {
      return compareObjects(obj1, obj2);
};

// Example usage:
const object1 = {
    name: 'Abhi',
    age: 30,
    address: {
        city: 'New York',
        zip: '10001'
    },
    hobbies: ['reading', 'swimming'],
    company: 'Quest'
};

const object2 = {
    name: 'Bharti',
    age: 31,
    address: {
        city: 'Boston',
        state: 'Bihar',
        zip: '10001'
    },
    phone: '123-456-7890'
};

// const differences = getObjectDifferences(object1, object2);